import { Controller } from '@hotwired/stimulus';
import offlineProgressSync from '../src/react/helpers/OfflineProgressSync';

export default class extends Controller {
  connect() {
    offlineProgressSync.syncIfOnline();
  }

  async retry() {
    await offlineProgressSync.retryFailed();
  }

  async discard() {
    await offlineProgressSync.discardFailed();
  }
}
